import React from 'react';
import { TableRow, TableCell, Autocomplete, TextField, Typography, MenuItem, ListItemText, Tooltip, IconButton, Box } from '@mui/material';

import { makeStyles } from '@mui/styles';
import { grey } from '@mui/material/colors';
import { AddBox, Close } from '@mui/icons-material';
import LabelIcon from '../Components/LabelIcon'; // adjust path accordingly
import { MoneyFormatv3 } from '../../../library/MoneyFormat';
import theme from '../../../styles/Themecolors';
import { MoneyTextField } from '../../../components';
import { useSelector } from 'react-redux';

const ItemRow = ({
  col,
  index,
  key,
  viewMode,
  itemCodes,
  itemNames,
  itemValid,
  classes,
  invoiceEntry,
  registrationType,
  data,
  handleItemCodeChange,
  handleItemCodeInputChange,
  handleItemCodeKeyDown,
  handleItemNameChange,
  handleItemNameInputChange,
  handleItemNameKeyDown,
  handlePriceTypeChange,
  handlePriceTypeKeyDown,
  handleReasonChange,
  handleReasonKeyDown,
  handleGSTRateChange,
  handleGSTRateKeyDown,
  handleHSNChange,
  handleHSNInputChange,
  handleHSNKeyDown,
  handleQuantityChange,
  handleQuantityKeyDown,
  handleRateChange,
  handleRateKeyDown,
  handleRateBlur,
  handleDiscountChange,
  handleDiscountKeyDown,
  handleDiscountBlur,
  handleGstCessChange,
  handleGstCessKeyDown,
  handleGstCessBlur,
  handleGstAmtBlur,
  handleUnitsChange,
  handleUnitsKeyDown,
  handleTextKeyDown,
  ListboxProps,
  PaperComponent,
  setOpenItemModal,
  setItemID,
  setItemType,
  setItemName,
  setRowIndex,
  getPriceList,
  Type,
  partyType,
  companyType,
  EInvoiceFlag,
  loadingPriceType,
  gstOrCompositeRate,
  compositeRate,
  units,
  unitsObj,
  filterHSN,
  items,
  HSNListboxProps,
  companyData,
  textFieldRef,
  scrollToField,
  ToolTipComponent,
  saveChangesInRows,
  closeChangesInRows,
  setDeleteEntriesModal,
  setUpdatedTableRow,
  setOpenHsnModal,
  setHSNParamsID,
  companyState,
  params
}) => {
  const getCompany = useSelector((state) => state?.companyReducer?.companyDetails);
  const isCessFlag= params?.id?params?.cessexist:getCompany?.relatedcompanydetailsnew?.[0]?.gstcompensationcessflag;
  const useStyles = makeStyles({
    table: {
      '& .MuiTableCell-root': {
        border: '1px solid rgba(224, 224, 224, 1)',
        borderBottom: '2px solid rgba(224, 224, 224, 1)',
      },
    },
    newTableCell: {
      '& .MuiTableCell-root': {
        borderTop: '3px solid #9b6ab7 !important', // Top border
        borderBottom: '3px solid #9b6ab7', // Bottom border
        borderLeft: '3px solid #9b6ab7', // Left border
        borderRight: '3px solid #9b6ab7', // Right border
      },
    },

    errorTableCell: {
      border: '3px solid red !important',
    },
    stickyCell: {
      position: 'sticky',
      right: 0,
      minWidth: '70px',
      backgroundColor: theme.palette.bodyGray.secondary,
      zIndex: 10, // Ensure the sticky cell appears above other cells
      boxShadow: '-5px 0 0 0 red', // Simulate a left border with shadow
      outline: 'none',
      '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        width: '1px', // Adjust this value for the desired border thickness
        backgroundColor: 'rgba(224, 224, 224, 1)', // Border color
        zIndex: 11, // Ensure it appears above the cell content
        outline: 'none',
      },
      '&:focus': {
        outline: 'none', // This will remove the outline on focus
      },
    },
  });

  const tabelCellClass = useStyles();

  return (
    <TableRow
      onClick={() => {
        if (col?.itemCode?.value) {
          getPriceList(col.itemCode.value, index);
        }
      }}
      className={tabelCellClass.table}
      hover
      role="checkbox"
      sx={{
        height: '0px',
      }}
      key={index}
    >
      <TableCell className={col?.invalidDate ? tabelCellClass?.errorTableCell : ''} align="left">
        <Typography sx={{ fontSize: '14px' }}>{index + 1}</Typography>
      </TableCell>

      <TableCell className={(col?.itemCode?.label === '' && !itemValid) || col?.invalidDate ? tabelCellClass?.errorTableCell : ''}>
        <Tooltip title={col?.itemCode?.label}>
          <Autocomplete
            className={classes.autocomplete}
            openOnFocus
            autoFocus
            disableClearable
            id={'itemCode' + index}
            name={'itemCode' + index}
            options={['Add Item', ...(itemCodes || [])]}
            disabled={data?.partyName?.label === '' || viewMode === true}
            value={col?.itemCode}
            isOptionEqualToValue={(option, value) => option.value === value.value}
            componentsProps={{
              popper: { style: { width: 'fit-content' } },
            }}
            onChange={(e, newValue) => handleItemCodeChange(e, newValue, index)}
            onInputChange={(e, newInputValue, reason) => {
              if (reason === 'input') {
                handleItemCodeInputChange(e, newInputValue, index);
              }
            }}
            onKeyDown={(e) => handleItemCodeKeyDown(e, index)}
            // ListboxProps={ListboxProps}
                                                   ListboxProps={{
  sx: {
     '& .MuiAutocomplete-option': {
        paddingTop: '3px !important',
        paddingBottom: '3px !important',
        minHeight: '25px !important',
        
      },
  },
}}
            PaperComponent={PaperComponent}
            sx={{
              '& .MuiOutlinedInput-root': {
                border: 'none',
                outline: 'none',
                boxShadow: 'none',
                '&:hover': {
                  border: 'none',
                  outline: 'none',
                },
                '&.Mui-focused': {
                  border: 'none',
                  outline: 'none',
                  boxShadow: 'none',
                },
                '& fieldset': {
                  border: 'none !important',
                },
              },
              '& .MuiOutlinedInput-input': {
                outline: 'none',
              },
              '&:focus-visible': {
                outline: 'none',
                boxShadow: 'none',
              },
              width: registrationType === 1 ? '100%' : 140,
            }}
            size="small"
            renderInput={(params) => (
              <TextField
                {...params}
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: invoiceEntry?.length === 0 && (
                    <LabelIcon
                      value={col?.itemCode?.value}
                      params={params.InputProps.endAdornment}
                      setOpen={setOpenItemModal}
                      setParamsID={setItemID}
                      editMode={true}
                      setItemType={setItemType}
                      itemType={col?.itemType}
                      setItemName={setItemName}
                      type="Accounts"
                    />
                  ),
                }}
              />
            )}
            renderOption={(props, option) =>
              option === 'Add Item' ? (
                <MenuItem
                  value="addItem"
                  onClick={(event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    setItemID('');
                    setItemType('');
                    setItemName('');
                    setOpenItemModal(true);
                    setRowIndex(index);
                  }}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    position: 'sticky',
                    mt: '-8px !important',
                    top: '-8px !important',
                    zIndex: 1,
                    backgroundColor: grey[50],
                    '&:hover': {
                      backgroundColor: grey[200],
                    },
                  }}
                >
                  <AddBox fontSize="small" sx={{ marginRight: '5px', color: 'primary.main' }} />
                  <ListItemText sx={{ color: 'primary.main' }} primary="Add Item" />
                </MenuItem>
              ) : (
                <MenuItem {...props} key={option.value} value={option.value}>
                  <ListItemText    primary={option?.label}
    primaryTypographyProps={{
      fontSize: '16px',     
      lineHeight: '20px',
      fontWeight: 400
    }}/>
                </MenuItem>
              )
            }
          />
        </Tooltip>
      </TableCell>
      <TableCell
        align="left"
        className={(col?.name?.label === '' && itemValid === false) || col?.invalidDate ? tabelCellClass?.errorTableCell : ''}
      >
        <Tooltip title={col?.name?.label}>
          <Autocomplete
            disableClearable
            className={classes.autocomplete}
            openOnFocus
            id={'itemName' + index}
            name={'itemName' + index}
            options={['Add Item', ...(itemNames || [])]}
            value={col?.name}
            isOptionEqualToValue={(option, value) => option.value === value.value}
            componentsProps={{
              popper: { style: { width: 'fit-content' } },
            }}
            disabled={data?.partyName?.label == '' || viewMode === true ? true : false}
            onChange={(e, newValue) => handleItemNameChange(e, newValue, index)}
            onInputChange={(event, newInputValue, reason) => {
              if (reason === 'input') {
                handleItemNameInputChange(event, newInputValue, index); // include `index` if needed
              }
            }}
            onKeyDown={(e) => handleItemNameKeyDown(e, index)}
            // ListboxProps={ListboxProps}
                                                   ListboxProps={{
  sx: {
     '& .MuiAutocomplete-option': {
        paddingTop: '3px !important',
        paddingBottom: '3px !important',
        minHeight: '25px !important',
      
      },
  },
}}
            PaperComponent={PaperComponent}
            sx={{
              '& .MuiOutlinedInput-root': {
                border: 'none',
                outline: 'none',
                boxShadow: 'none',
                '&:hover': {
                  border: 'none',
                  outline: 'none',
                },
                '&.Mui-focused': {
                  border: 'none',
                  outline: 'none',
                  boxShadow: 'none',
                },
                '& fieldset': {
                  border: 'none !important',
                },
              },

              // Extra safety to remove outline from input itself
              '& .MuiOutlinedInput-input': {
                outline: 'none',
              },

              // Remove global focus-visible ring
              '&:focus-visible': {
                outline: 'none',
                boxShadow: 'none',
              },
              width: registrationType === 1 ? '100%' : 140,
            }}
            size="small"
            renderInput={(params) => (
              <TextField
                InputLabelProps={{
                  shrink: true,
                }}
                autoFocus={false}
                {...params}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: invoiceEntry?.length === 0 && (
                    <>
                      <LabelIcon
                        value={col?.name?.value}
                        params={params.InputProps.endAdornment}
                        setOpen={setOpenItemModal}
                        setParamsID={setItemID}
                        setItemName={setItemName}
                        setItemType={setItemType}
                        itemType={col?.itemType}
                        editMode={true}
                        type="Accounts"
                      />
                    </>
                  ),
                }}
              />
            )}
            renderOption={(props, option) => (
              <>
                {option === 'Add Item' ? (
                  <MenuItem
                    value={'addItem'}
                    onClick={(event) => {
                      event.stopPropagation();
                      event.preventDefault();
                      setItemID('');
                      setItemType('');
                      setItemName('');
                      setOpenItemModal(true);
                      setRowIndex(index);
                    }}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      position: 'sticky',
                      // bottom: "-7.5px",
                      mt: '-8px !important',
                      top: '-8px !important',
                      zIndex: 1,
                      backgroundColor: grey[50],
                      '&:hover': {
                        backgroundColor: grey[200],
                      },
                    }}
                  >
                    <AddBox
                      fontSize="small"
                      sx={{
                        marginRight: '5px',
                        color: 'primary.main',
                      }}
                    />
                    <ListItemText sx={{ color: 'primary.main' }} primary={'Add Item'} />
                  </MenuItem>
                ) : (
                  <MenuItem {...props} key={option.value} value={option.value}>
                    <ListItemText  primaryTypographyProps={{
      fontSize: '16px',     
      lineHeight: '20px',
      fontWeight: 400
    }} primary={option?.label} />
                  </MenuItem>
                )}
              </>
            )}
          />
        </Tooltip>
      </TableCell>
      {/* {partyType === "CUSTOMER" && ( */}
      <TableCell align="left" className={col?.invalidDate ? tabelCellClass?.errorTableCell : ''}>
        <Autocomplete
          disableClearable
          className={classes.autocomplete}
          id={'priceType' + index}
          options={col?.priceTypeArr || []}
          value={col?.priceType}
          isOptionEqualToValue={(option, value) => option.value === value.value}
          componentsProps={{
            popper: { style: { width: 'fit-content' } },
          }}
          loading={loadingPriceType}
          loadingText="Loading..."
          disabled={data?.partyName?.label == '' || viewMode === true ? true : false}
          onChange={(e, newValue) => handlePriceTypeChange(e, newValue, index)}
          onKeyDown={(e) => handlePriceTypeKeyDown(e, index)}
          sx={{
            '& .MuiOutlinedInput-root': {
              border: 'none',
              outline: 'none',
              boxShadow: 'none',
              '&:hover': {
                border: 'none',
                outline: 'none',
              },
              '&.Mui-focused': {
                border: 'none',
                outline: 'none',
                boxShadow: 'none',
              },
              '& fieldset': {
                border: 'none !important',
              },
            },

            // Extra safety to remove outline from input itself
            '& .MuiOutlinedInput-input': {
              outline: 'none',
            },

            // Remove global focus-visible ring
            '&:focus-visible': {
              outline: 'none',
              boxShadow: 'none',
            },
            width: registrationType === 1 ? '100%' : 140,
          }}
          size="small"
          renderInput={(params) => (
            <TextField
              InputLabelProps={{
                shrink: true,
              }}
              {...params}
              InputProps={{
                ...params.InputProps,
              }}
            />
          )}
        />
      </TableCell>
      {/* )} */}
      {(Type === 'DebitNote' || Type === 'CreditNote') && (
        <TableCell align="left" className={col?.invalidDate ? tabelCellClass?.errorTableCell : ''}>
          <Tooltip title={col?.reason}>
            <TextField
              size="small"
              id={'reason' + index}
              name={'reason' + index}
              value={col?.reason}
              disabled={viewMode === true ? true : false}
              onChange={(e) => handleReasonChange(e, index)}
              onKeyDown={(e) => handleReasonKeyDown(e, index)}
              sx={{
                '& .MuiOutlinedInput-root': {
                  border: 'none',
                  outline: 'none',
                  boxShadow: 'none',
                  '&:hover': {
                    border: 'none',
                    outline: 'none',
                  },
                  '&.Mui-focused': {
                    border: 'none',
                    outline: 'none',
                    boxShadow: 'none',
                  },
                  '& fieldset': {
                    border: 'none !important',
                  },
                },

                // Extra safety to remove outline from input itself
                '& .MuiOutlinedInput-input': {
                  outline: 'none',
                },

                // Remove global focus-visible ring
                '&:focus-visible': {
                  outline: 'none',
                  boxShadow: 'none',
                },
                // minWidth: 180,
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Tooltip>
        </TableCell>
      )}
      {registrationType !== 1 && (
        <>
          {data?.taxability?.value !== 2 && data?.taxability?.value !== 3 && data?.taxability?.value !== 5 && (
            <TableCell
              align="left"
              className={
                (col?.GSTRate === '' &&
                  itemValid === false &&
                  (data?.taxability?.value == 1 ||
                    data?.taxability?.value == 4 ||
                    data?.taxability?.value == 6 ||
                    data?.taxability?.value == 8 ||
                    data?.taxability?.value == 9 ||
                    data?.taxability?.value == 7 ||
                    data?.taxability?.value === '')) ||
                col?.invalidDate
                  ? tabelCellClass?.errorTableCell
                  : ''
              }
            >
              <Autocomplete
                disableClearable
                id={'GSTRate' + index}
                openOnFocus
                autoFocus
                disabled={
                  registrationType !== 3
                    ? data?.taxability?.value === 2 ||
                      data?.taxability?.value === 3 ||
                      data?.taxability?.value === 5 ||
                      col?.itemCode?.value === '' ||
                      viewMode === true
                      ? true
                      : false
                    : data?.taxability?.value === 2 ||
                      data?.taxability?.value === 3 ||
                      data?.taxability?.value === 5 ||
                      col?.itemCode?.value === '' ||
                      viewMode === true ||
                      (companyType == 3 && (partyType === 'CUSTOMER' || Type === 'Pos'))
                    ? true
                    : false
                }
                value={
                  (companyType == 3 ? (partyType === 'SUPPLIER' ? gstOrCompositeRate : compositeRate) : gstOrCompositeRate)?.find(
                    (item) => item.id === col?.GSTRate
                  ) || null
                }
                options={companyType == 3 ? (partyType === 'SUPPLIER' ? gstOrCompositeRate : compositeRate) : gstOrCompositeRate}
                isOptionEqualToValue={(option, value) => option.value === value.value}
                getOptionLabel={(option) => option.rate}
                onChange={(event, newValue) => handleGSTRateChange(newValue, index, 0)}
                onKeyDown={(e) => handleGSTRateKeyDown(e, index)}
                className={classes.autocomplete}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    border: 'none',
                    outline: 'none',
                    boxShadow: 'none',
                    '&:hover': {
                      border: 'none',
                      outline: 'none',
                    },
                    '&.Mui-focused': {
                      border: 'none',
                      outline: 'none',
                      boxShadow: 'none',
                    },
                    '& fieldset': {
                      border: 'none !important',
                    },
                  },

                  // Extra safety to remove outline from input itself
                  '& .MuiOutlinedInput-input': {
                    outline: 'none',
                  },

                  // Remove global focus-visible ring
                  '&:focus-visible': {
                    outline: 'none',
                    boxShadow: 'none',
                  },
                  width: 70,
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name="GSTRate"
                    label=""
                    variant="outlined"
                    size="small"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                  />
                )}
              />
            </TableCell>
          )}
          <TableCell
            className={
              col?.invalidDate ||
              ((col?.HSN?.value === '' || col?.HSN?.value === undefined || col?.HSN.value === undefined) &&
                // EInvoiceFlag &&
                // Type === "Sales"
                companyType === 2 &&
                // &&
                // data.partyCategory !== "UB"
                registrationType !== 1 &&
                itemValid === false)
                ? tabelCellClass?.errorTableCell
                : ''
            }
            align="left"
          >
            <Tooltip title={col?.HSN?.label}>
              <Autocomplete
                disableClearable
                id={'hsnCode' + index}
                openOnFocus
                options={['Add HSN/SAC Code', ...(filterHSN || [])]}
                componentsProps={{
                  popper: {
                    style: {
                      maxWidth: 300,
                      overflow: 'auto',
                    },
                  },
                }}
                disabled={col?.name?.label === '' || viewMode === true ? true : false}
                // noOptionsText={"Search"}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    border: 'none',
                    outline: 'none',
                    boxShadow: 'none',
                    '&:hover': {
                      border: 'none',
                      outline: 'none',
                    },
                    '&.Mui-focused': {
                      border: 'none',
                      outline: 'none',
                      boxShadow: 'none',
                    },
                    '& fieldset': {
                      border: 'none !important',
                    },
                  },

                  // Extra safety to remove outline from input itself
                  '& .MuiOutlinedInput-input': {
                    outline: 'none',
                  },

                  // Remove global focus-visible ring
                  '&:focus-visible': {
                    outline: 'none',
                    boxShadow: 'none',
                  },
                  minWidth: 120,
                }}
                value={col?.HSN}
                isOptionEqualToValue={(option, value) => option.value === value.value}
                className={classes.autocomplete}
                onChange={(e, newValue) => handleHSNChange(e, newValue, index)}
                onKeyDown={(e) => handleHSNKeyDown(e, index)}
                size="small"
                onInputChange={(e, newValue) => handleHSNInputChange(e, newValue)}
                ListboxProps={HSNListboxProps}
                renderOption={(props, option) => (
                  <>
                    {option === 'Add HSN/SAC Code' ? (
                      <MenuItem
                        value={'addHsn'}
                        onClick={(event) => {
                          event.stopPropagation();
                          event.preventDefault();
                          const updatedTableArr = [...items];
                          setUpdatedTableRow(updatedTableArr);
                          setRowIndex(index);
                          setOpenHsnModal(true);
                          setHSNParamsID('');
                        }}
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          position: 'sticky',
                          // bottom: "-7.5px",
                          mt: '-8px !important',
                          top: '-8px !important',
                          backgroundColor: grey[50],
                          '&:hover': {
                            backgroundColor: grey[200],
                          },
                        }}
                      >
                        <AddBox
                          fontSize="small"
                          sx={{
                            marginRight: '5px',
                            color: 'primary.main',
                          }}
                        />
                        <ListItemText sx={{ color: 'primary.main' }} primary={'Add HSN/SAC Code'} />
                      </MenuItem>
                    ) : (
                      <li {...props}>{option?.label}</li>
                    )}
                  </>
                )}
                renderInput={(params) => (
                  <TextField
                    InputLabelProps={{
                      shrink: true,
                    }}
                    placeholder="Search"
                    onClick={() => {
                      setItemType(col.itemType);
                    }}
                    {...params}
                    label=""
                  />
                )}
              />
            </Tooltip>
          </TableCell>
        </>
      )}
      <TableCell className={col?.invalidDate ? tabelCellClass?.errorTableCell : ''} align="right">
        <TextField
          value={col?.qty}
          onChange={(e) => handleQuantityChange(e, index)}
          // onBlur={() => handleQuantityBlur(index)}
          disabled={col.name?.value == '' || viewMode === true ? true : false}
          id={'qty' + index}
          label=""
          type="number"
          variant="outlined"
          size="small"
          fullWidth
          sx={{
            '& .MuiOutlinedInput-root': {
              border: 'none',
              outline: 'none',
              boxShadow: 'none',
              '&:hover': { border: 'none', outline: 'none' },
              '&.Mui-focused': { border: 'none', outline: 'none', boxShadow: 'none' },
              '& fieldset': { border: 'none !important' },
            },
            '& .MuiOutlinedInput-input': {
              outline: 'none',
              // Hide arrows (Chrome, Safari, Edge, etc.)
              '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
                WebkitAppearance: 'none',
                margin: 0,
              },
              // Hide arrows (Firefox)
              MozAppearance: 'textfield',
              textAlign: 'right',
            },
            '&:focus-visible': { outline: 'none', boxShadow: 'none' },
            width: 100,
          }}
          onKeyDown={(e) => handleQuantityKeyDown(e, index)}
        />
      </TableCell>

      <TableCell className={col?.invalidDate ? tabelCellClass?.errorTableCell : ''} align="left">
        <Tooltip title={unitsObj[col?.units]}>
          <Autocomplete
            id={'units' + index}
            openOnFocus
            disableClearable
            value={units?.find((unit) => unit.value === col?.units) || null}
            className={classes.autocomplete}
            componentsProps={{
              popper: { style: { width: 'fit-content' } },
            }}
            onChange={(event, newValue) => handleUnitsChange(event, newValue, index)}
            onKeyDown={(e) => handleUnitsKeyDown(e, index)}
            sx={{
              '& .MuiOutlinedInput-root': {
                border: 'none',
                outline: 'none',
                boxShadow: 'none',
                '&:hover': {
                  border: 'none',
                  outline: 'none',
                },
                '&.Mui-focused': {
                  border: 'none',
                  outline: 'none',
                  boxShadow: 'none',
                },
                '& fieldset': {
                  border: 'none !important',
                },
              },

              // Extra safety to remove outline from input itself
              '& .MuiOutlinedInput-input': {
                outline: 'none',
              },

              // Remove global focus-visible ring
              '&:focus-visible': {
                outline: 'none',
                boxShadow: 'none',
              },
              width: registrationType === 1 ? '100%' : 140,
            }}
            isOptionEqualToValue={(option, value) => option.value === value?.value}
            disabled={
              true
              // col?.name?.value === "" || viewMode === true
              //   ? true
              //   : false
            }
            options={units}
            getOptionLabel={(option) => option.option}
            renderInput={(params) => (
              <TextField {...params} label="" variant="outlined" size="small" fullWidth InputLabelProps={{ shrink: true }} />
            )}
          />
        </Tooltip>
      </TableCell>

      <TableCell
        align="right"
        sx={{ outline: 'none' }}
        className={((col?.rate === '' || col?.rate == 0) && itemValid === false) || col?.invalidDate ? tabelCellClass?.errorTableCell : ''}
      >
        <MoneyTextField
          value={col?.rate?Number(col?.rate):null}
          //onClick={moveCursorToEnd}
              // onChange={(e) => handleRateChange(e, index)}
          onChange={(val) => handleRateChange((val), index)}
          // onBlur={() => handleRateBlur(index)}
          onKeyDown={(e) => handleRateKeyDown(e, index)}
          type="text"
          disabled={col?.name?.value == '' || viewMode === true ? true : false}
          id={'rate' + index}
          name={'rate' + index}
          label=""
          variant="outlined"
          size="small"
          fullWidth
          min={0}
          max={9999999999}
          maxErrorMessage='Maximum 10 digits allowed before decimal.'
          InputProps={{
            inputProps: {
              style: {
                textAlign: 'right',
                paddingRight: '0px',
              },
              min: 0,
            },
          }}
          sx={{
            outline: 'none',
            '& .MuiOutlinedInput-root': {
              border: 'none',
              outline: 'none',
              boxShadow: 'none',
              '&:hover': {
                border: 'none',
                outline: 'none',
              },
              '&.Mui-focused': {
                border: 'none',
                outline: 'none',
                boxShadow: 'none',
              },
              '& fieldset': {
                border: 'none !important',
              },
            },

            // Extra safety to remove outline from input itself
            '& .MuiOutlinedInput-input': {
              outline: 'none',
            },

            // Remove global focus-visible ring
            '&:focus-visible': {
              outline: 'none',
              boxShadow: 'none',
            },
            minWidth: 120,
          }}
        />
      </TableCell>
      <TableCell className={col?.invalidDate ? tabelCellClass?.errorTableCell : ''} align="right">
        <Typography
          tabIndex={0}
          id={'amount' + index}
          sx={{
            fontSize: '14px',
            minWidth: 100,
            outline: 'none',
          }}
          onKeyDown={(e) => {
            const warMsg = '';

            const currentId = 'amount' + index;
            const nextId = 'dicount' + index;
            const prevID = 'rate' + index;

            const required = false;
            handleTextKeyDown(
              e,

              currentId,
              nextId,
              required,
              warMsg,
              prevID
            );
          }}
        >
          {MoneyFormatv3(Number(col?.amount).toFixed(2), 'en-IN')}
        </Typography>
      </TableCell>

      <TableCell className={col?.invalidDate ? tabelCellClass?.errorTableCell : ''} align="right">
        <MoneyTextField
          inputRef={textFieldRef}
          onFocus={(e) => {
            scrollToField();
          }}
          value={col?.dicount?Number(col?.dicount):null}
          state={col}
          min={0}
          max={Number(col.amount)-0.01}
          maxErrorMessage='Discount should  be less than amount applied'
          //onClick={moveCursorToEnd}
          // onChange={(e) => handleDiscountChange(e, index)}
          onChange={(val) => handleDiscountChange(val, index)}
          // onBlur={() => handleDiscountBlur(index)}
          onKeyDown={(e) => handleDiscountKeyDown(e, index)}
          sx={{
            '& .MuiOutlinedInput-root': {
              border: 'none',
              outline: 'none',
              boxShadow: 'none',
              '&:hover': {
                border: 'none',
                outline: 'none',
              },
              '&.Mui-focused': {
                border: 'none',
                outline: 'none',
                boxShadow: 'none',
              },
              '& fieldset': {
                border: 'none !important',
              },
            },

            // Extra safety to remove outline from input itself
            '& .MuiOutlinedInput-input': {
              outline: 'none',
            },

            // Remove global focus-visible ring
            '&:focus-visible': {
              outline: 'none',
              boxShadow: 'none',
            },
            minWidth: 120,
          }}
          disabled={col?.rate === 0 || viewMode === true ? true : false}
          id={'dicount' + index}
          name={'dicount ' + index}
          label=""
          type="text"
          variant="outlined"
          size="small"
          fullWidth
          InputProps={{
            inputProps: {
              style: {
                textAlign: 'right',
                paddingRight: '0px',
              },
              min: 0,
            },
          }}
        />
      </TableCell>

      {registrationType !== 1 && !(registrationType === 3 && (Type === 'Sales' || Type === 'Pos' || partyType === 'CUSTOMER')) && (
        <>
          <TableCell className={col?.invalidDate ? tabelCellClass?.errorTableCell : ''} align="right">
            <Typography
              tabIndex={0}
              id={'taxableAMount' + index}
              onKeyDown={(e) => {
                const warMsg = '';

                const currentId = 'taxableAMount' + index;
                const nextId = [2, 3, 5,7,9].includes(data?.taxability?.value) ? 'netAmount' + index : 'IGST' + index;
                const prevID = 'dicount' + index;

                const required = false;
                handleTextKeyDown(
                  e,

                  currentId,
                  nextId,
                  required,
                  warMsg,
                  prevID
                );
              }}
              sx={{
                fontSize: '14px',
                width: 100,
                outline: 'none',
              }}
            >
              {MoneyFormatv3(Number(col?.taxableAMount).toFixed(2), 'en-IN')}
            </Typography>
          </TableCell>
          {data?.taxability?.value !== 2 && data?.taxability?.value !== 3 && data?.taxability?.value !== 5 && (
            <TableCell className={col?.invalidDate ? tabelCellClass?.errorTableCell : ''} align="right">
              <MoneyTextField
                id={'IGST' + index}
                variant="standard"
                value={col?.IGST?Number(col?.IGST):null}
                // onBlur={() => handleGstAmtBlur(index)}
                min={0}
                disabled={[2, 3, 5,7,9].includes(data?.taxability?.value)}
                // onChange={(e) => {
                //   let newValue = e.target.value.replace(/,/g, '');
                //   if (newValue === '') {
                //     handleGSTRateChange(0, index, 1);
                //     return;
                //   }
                //   if (!/^\d*\.?\d*$/.test(newValue)) return;
                //   const decimalPart = newValue.split('.')[1];
                //   if (decimalPart && decimalPart.length > 2) return;
                //   handleGSTRateChange(newValue, index, 1);
                // }}
                onChange={(newValue) => {
                  
                  handleGSTRateChange(newValue, index, 1);
                }}
                onKeyDown={(e) => {
                  const cessFlag =Number(isCessFlag);
                  const warMsg = '';

                  const currentId = 'IGST' + index;
                  const nextId =
                    (cessFlag == 1 && (Type === 'Sales' || Type === 'Pos')) ||
                    Type === 'Purchase' ||
                    Type === 'DebitNote' ||
                    Type === 'CreditNote'
                      ? 'gstCess' + index
                      : 'netAmount' + index;
                  const prevID = 'taxableAMount' + index;

                  const required = false;

                  handleTextKeyDown(e, currentId, nextId, required, warMsg, prevID);
                }}
                InputProps={{
                  disableUnderline: true,
                  style: { minWidth: '80px', textAlign: 'right' },
                  readOnly: (!col?.rate && !col?.qty) || partyType === 'CUSTOMER' ? true : false,
                  
                }}
                
                inputProps={{
                   disableUnderline: true,
                  style: { minWidth: '80px', textAlign: 'right' },
                  readOnly: (Number(col?.taxableAMount)===0) || partyType === 'CUSTOMER' ? true : false,
                }}
              />
            </TableCell>
          )}

          {((Type !== 'Sales' && Type !== 'Pos') || Number(isCessFlag) !== 0) &&
            data?.taxability?.value !== 2 &&
            data?.taxability?.value !== 3 &&
            data?.taxability?.value !== 5 && (
              <TableCell className={col?.invalidDate ? tabelCellClass?.errorTableCell : ''} align="right">
                <MoneyTextField
                  value={col?.GSTCess?Number(col?.GSTCess):null}
                  //onClick={moveCursorToEnd}
                  name={'gstCess' + index}
                  id={'gstCess' + index}
                  min={0}
                  max={Number(col.taxableAMount)-0.01}
                  maxErrorMessage='Cess amount should be less than the taxable amount'
                  // onChange={(e) => handleGstCessChange(e, index)}
                    onChange={(val) => handleGstCessChange(val, index)}
                  // onBlur={() => handleGstCessBlur(index)}
                  onKeyDown={(e) => handleGstCessKeyDown(e, index)}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      border: 'none',
                      outline: 'none',
                      boxShadow: 'none',
                      '&:hover': {
                        border: 'none',
                        outline: 'none',
                      },
                      '&.Mui-focused': {
                        border: 'none',
                        outline: 'none',
                        boxShadow: 'none',
                      },
                      '& fieldset': {
                        border: 'none !important',
                      },
                    },

                    // Extra safety to remove outline from input itself
                    '& .MuiOutlinedInput-input': {
                      outline: 'none',
                    },

                    // Remove global focus-visible ring
                    '&:focus-visible': {
                      outline: 'none',
                      boxShadow: 'none',
                    },
                    width: 100,
                  }}
                  disabled={
                    registrationType !== 3
                      ? data?.taxability?.value === 2 ||
                        data?.taxability?.value === 3 ||
                        data?.taxability?.value === 5 ||
                        col?.itemCode?.value === '' ||
                        data?.taxability?.value === 7 || data?.taxability?.value === 9 ||
                        viewMode === true || Number(col?.taxableAMount)===0
                        ? true
                        : false
                      : data?.taxability?.value === 2 ||
                        data?.taxability?.value === 3 ||
                        data?.taxability?.value === 5 ||
                        col?.itemCode?.value === '' ||
                        data?.taxability?.value === 7 ||    data?.taxability?.value === 9 ||
                        viewMode === true || Number(col?.taxableAMount)===0
                      ? true
                      : false
                  }
                  label=""
                  type="text"
                  variant="outlined"
                  size="small"
                  fullWidth
                  InputProps={{
                    inputProps: {
                      style: {
                        textAlign: 'right',
                        paddingRight: '0px',
                      },
                      min: 0,
                    },
                  }}
                />
              </TableCell>
            )}
        </>
      )}

      <TableCell className={col?.invalidDate ? tabelCellClass?.errorTableCell : ''} align="right">
        <Typography
          tabIndex={0}
          id={'netAmount' + index}
          sx={{
            fontSize: '14px',
            width: registrationType === 1 ? '100%' : 120,
            outline: 'none',
          }}
          onKeyDown={(e) => {
            const cessFlag = Number(isCessFlag);
            if (e.key === 'Tab' && e.shiftKey) {
              e.preventDefault();
              e.stopPropagation();
              const element = registrationType !== 1 ? (cessFlag == 1 ? 'gstCess' + index : 'IGST' + index) : 'dicount' + index;
              document.getElementById(element)?.focus();
            }
            if ((e.key === 'Tab' && !e.shiftKey) || e.key === 'Enter') {
              e.preventDefault();
              e.stopPropagation();
              setRowIndex(index);
              saveChangesInRows(index);
            }
          }}
        >
          {MoneyFormatv3(Number(col?.netAmount).toFixed(2), 'en-IN')}
        </Typography>
      </TableCell>

      <TableCell
        align="right"
        sx={{
          backgroundColor: '#FFF',
          position: 'sticky',
          right: 0,
          border: col?.invalidDate ? '3px solid red !important' : '',

          zIndex: 1,
        }}
        // className="actionBackGround"
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <>
            <IconButton
              disabled={viewMode === true ? true : false}
              disableRipple
              aria-label="delete"
              sx={{
                margin: '0px 2px',
                padding: '5px',
                backgroundColor:
                  // col.new === true ?
                  '#fbc7c78c',
                //  : "#83ff7b7a",
              }}
              onClick={() => {
                if (col?.itemCode?.label === '') {
                  closeChangesInRows(index);
                } else {
                  setRowIndex(index);
                  setDeleteEntriesModal(true);
                }
              }}
            >
              <Close
                sx={{
                  fontSize: '18px',
                  color: '#eb6a6a',
                }}
              />
            </IconButton>
          </>
        </Box>
      </TableCell>
    </TableRow>
  );
};

const ItemRowMemo = React.memo(ItemRow, (prev, next) => {
  return (
    prev.col === next.col &&
    prev.index === next.index &&
    prev.viewMode === next.viewMode &&
    prev.itemValid === next.itemValid &&
    prev.itemCodes === next.itemCodes &&
    prev.data?.partyName?.label === next.data?.partyName?.label &&
    prev.registrationType === next.registrationType &&
    prev.data?.taxability?.value === next.data?.taxability?.value &&
    prev.filterHSN === next.filterHSN &&
    prev.getPriceList === next.getPriceList
  );
});

export default ItemRowMemo;
